module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp",
    attrs: {
      "id": "generate"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_vm._v("\n        上記のグラフの正規分布に従ってランダムな身長を生成します。"), _c('br'), _vm._v(" "), _c('mdl-textfield', {
    attrs: {
      "floating-label": "下限確率",
      "type": "number"
    },
    model: {
      value: (_vm.min),
      callback: function($$v) {
        _vm.min = $$v
      },
      expression: "min"
    }
  }), _vm._v("% ～\n        "), _c('mdl-textfield', {
    attrs: {
      "floating-label": "上限確率",
      "type": "number"
    },
    model: {
      value: (_vm.max),
      callback: function($$v) {
        _vm.max = $$v
      },
      expression: "max"
    }
  }), _vm._v("%\n        "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.generate($event)
      }
    }
  }, [_vm._v("作成")]), _vm._v(" "), _c('h3', [_vm._v("プリセット")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("通常")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.setRange(0, 1)
      }
    }
  }, [_vm._v("0%～100%")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.setRange(0, 0.5)
      }
    }
  }, [_vm._v("0%～50%")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.setRange(0.5, 1)
      }
    }
  }, [_vm._v("50%～100%")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("端無し")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.setRange(0.02, 0.98)
      }
    }
  }, [_vm._v("2%～98%")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.setRange(0.02, 0.5)
      }
    }
  }, [_vm._v("2%～50%")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.setRange(.50, .98)
      }
    }
  }, [_vm._v("50%～98%")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("6分割")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised mini",
    nativeOn: {
      "click": function($event) {
        _vm.setRange(0, 1 / 6)
      }
    }
  }, [_vm._v("①")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised mini",
    nativeOn: {
      "click": function($event) {
        _vm.setRange(1 / 6, 2 / 6)
      }
    }
  }, [_vm._v("②")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised mini",
    nativeOn: {
      "click": function($event) {
        _vm.setRange(2 / 6, 3 / 6)
      }
    }
  }, [_vm._v("③")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised mini",
    nativeOn: {
      "click": function($event) {
        _vm.setRange(3 / 6, 4 / 6)
      }
    }
  }, [_vm._v("④")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised mini",
    nativeOn: {
      "click": function($event) {
        _vm.setRange(4 / 6, 5 / 6)
      }
    }
  }, [_vm._v("⑤")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised mini",
    nativeOn: {
      "click": function($event) {
        _vm.setRange(5 / 6, 6 / 6)
      }
    }
  }, [_vm._v("⑥")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "card-content border"
  }, [_c('span', {
    staticClass: "generated-height"
  }, [_vm._v(_vm._s(_vm.generated) + "cm")]), _vm._v(" (全体の"), _c('span', {
    staticClass: "generated-height"
  }, [_vm._v(_vm._s(_vm.heightPercent) + "%")]), _vm._v("の位置)"), _c('br')])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title mdl-color--primary mdl-color-text--primary-contrast "
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("ランダム作成")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7928a32a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Generate.vue
// module id = 190
// module chunks = 0